/**
 * United Arab Emirates dirham.
 */
export var AED = {
  code: 'AED',
  base: 10,
  exponent: 2
};